module.exports = __webpack_public_path__ + "static/work_bevog-65bf1ae96de084635abe0b279a3a394d.mp4";